export default "__VITE_ASSET__Cbin0CCG__"